import type {Location} from 'react-router-dom'

import {isValue} from '../../../../../utils/guards'
import {queryToObject} from '../../../../../utils/queryParams'
import {OrderByField, OrderDirection} from '../../../../packages/Tests/Tests.types'

type FilterQueryParams = {
  order: OrderDirection
  orderBy: OrderByField
}
export const getFilterQueryParams = (location: Location): FilterQueryParams => {
  const {order, orderBy} = queryToObject(location?.search)
  return {
    orderBy: isValue(OrderByField, orderBy) ? orderBy : OrderByField.BUILD_START_DATE,
    order: isValue(OrderDirection, order) ? order : OrderDirection.DESC,
  }
}
